import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import UserContext from "../contexts/UserContext";
import FetchUtil from "../utils/FetchUtil";
import { useNavigate } from "react-router-dom";

function PartnerProductTableRow({ index, partnerKey, buyerKey, handleSubmit, setError, t, setAdd, oddIdx }) {
	const navigate = useNavigate();
	const [productLoaded, setProductLoaded] = useState(false);
	const [productOptions, setProductOptions] = useState([]);
	const [productSelected, setProductSelected] = useState({ name: "productKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isProductLoading, setIsProductLoading] = useState(false);
	const userCtx = useContext(UserContext);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	
	useEffect(() => {
		fetchPartnerProducts(partnerKey);
	}, []);

	const productHandler = (selectedOption, action) => {
		let companyProductKey = selectedOption ? selectedOption.value : 0;
		let productName = selectedOption ? selectedOption.label : "";
		productSelected.value = companyProductKey;
		setProductSelected({ ...productSelected, label: (productName), value: companyProductKey });
	}
	function fetchPartnerProducts(partnerKey) {
		setError("");
		if (!partnerKey || partnerKey === 0) {
			return;
		}

		setIsProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				supplierKey: partnerKey, buyerKey: buyerKey,
				userCompanyId : userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartnerProducts", "/Service/CompanyService/GetPartnerProducts", requestOptions, retrieveCompanyProductSuccess, retrieveCompanyProductFail);
		} catch (error) {
			setIsProductLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveCompanyProductFail(redirect) {
		setIsProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getProdFailed"));
	}

	function retrieveCompanyProductSuccess(responseData) {
		let getPartnerProductResponse;
		if (responseData) {
			getPartnerProductResponse = responseData.getPartnerProductResponse;
			if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "0") {
				setProductValues(getPartnerProductResponse.products.slice())
			} else if (getPartnerProductResponse && getPartnerProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnerProductResponse) {
				setProductValues([]);
				setError(t("error.error") + " " + getPartnerProductResponse.errorMessage);
			} else {
				setProductValues([]);
				setError(t("error.system.fetch"));
			}
		}
		setIsProductLoading(false);
	}

	function setProductValues(productObj) {
		let productValue = {};
		let productOptionList = [];
		productOptionList.push({ label: "", value: 0 });
		if (productObj && productObj.length > 0) {
			productObj.map((aProduct, idx) => {
				productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
				productValue.value = aProduct.companyProductKey;
				productOptionList.push(productValue);
				productValue = {};
			});
		}
		setProductOptions(productOptionList);
		setProductSelected({ ...productSelected, label: "", value: 0 });
		setProductLoaded(true);
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			companyProductKey: productSelected.value,
			partnerKey: partnerKey
		};

		if (!partnerKey || partnerKey === 0) {
			setError(t("error.suplrReqd"));
			setIsSubmit(false);
		} else if (!productSelected.value || productSelected.value === 0) {
			setError(t("error.prodName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{productLoaded ? <Select
					name="companyProductKey"
					options={productOptions}
					onChange={productHandler}
					placeholder={""}
					value={productSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="productKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(productOptions && productOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default PartnerProductTableRow;